import { AfterViewInit, Component, inject, OnDestroy } from '@angular/core';

import { UnitService2 } from '../../services/unit2.service';
import { LayoutService } from '../layout.service';

@Component({
    selector: 'oc-layout',
    templateUrl: './oc-layout.component.html',
    styles: [':host { display: block; }', ':host ::ng-deep .layout-loading .sidenav-link { transition: none !important; }'],
    standalone: false,
})
export class OCLayout implements AfterViewInit, OnDestroy {
    private layoutService = inject(LayoutService);
    private readonly _unitService2 = inject(UnitService2);

    // Prevent "blink" effect
    public initialized = false;

    public ngAfterViewInit() {
        setTimeout(() => {
            this.initialized = true;

            this.layoutService.init();
            this.layoutService.update();
            this.layoutService.setAutoUpdate(true);
        });
    }

    public ngOnDestroy() {
        setTimeout(() => {
            this.layoutService.destroy();
        });
    }

    public closeSidenav() {
        const layoutWrapper = document.querySelector('#wrapper');
        if (layoutWrapper) {
            if (window.innerWidth > 768) {
                layoutWrapper.classList.toggle('sidenav-minimized');
            } else {
                layoutWrapper.classList.toggle('sidenav-visible');
            }
        }
    }
}
